import eventEmitter from "../emitter";
export function getDeviceType() {
    try {
        var userAgent = navigator.userAgent.toLowerCase();
        if (/android/.test(userAgent)) {
            return "android";
        }
        else if (/iphone|ipod/.test(userAgent)) {
            return "ios";
        }
        else if (/ipad/.test(userAgent)
            || ("platform" in navigator
                && navigator["platform"] === "MacIntel"
                && navigator.maxTouchPoints > 1)) {
            return "ios"; // iPad detection
        }
        return "web";
    }
    catch (err) {
        console.error("Error while resolving device type ", err);
        return "unknown";
    }
}
export function attachListeners(supportedListeners) {
    var _a, _b, _c, _d, _e, _f, _g;
    var listeners = [];
    var app = "native";
    var addListener = function (platform, postMessageFn, eventLevels) {
        listeners.push(function (t, p, eventLevel, supportedPlatforms) {
            try {
                var shouldPostEvent = eventLevels && eventLevels.length > 0 && eventLevel ? eventLevels.includes(eventLevel) : true;
                // Publish an event only to supported platform, if not provided by default publish to all
                var isPlatformSupported = supportedPlatforms && supportedPlatforms.length > 0 ? supportedPlatforms.includes(platform) : true;
                if (shouldPostEvent && isPlatformSupported) {
                    postMessageFn(t, p);
                    console.debug("[events/info] published event ".concat(t, " to platform ").concat(platform));
                }
            }
            catch (e) {
                console.error("[events/error] ".concat(platform, " events listener is not configured properly"), e);
            }
        });
        console.debug("[events/info] ".concat(platform, " events listener added"));
    };
    if (window.ReactNativeWebView && ((_a = supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners["react-native"]) === null || _a === void 0 ? void 0 : _a.enabled)) {
        app = "react-native";
        var eventLevels = ((supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners["react-native"]) || {}).eventLevels;
        var postMsgFn = function (t, p) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: t,
                payload: p,
            }));
        };
        addListener(PLATFORM.reactNative, postMsgFn, eventLevels);
    }
    else if (window.AnubhavFlutter && ((_b = supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners.flutter) === null || _b === void 0 ? void 0 : _b.enabled)) {
        app = "flutter";
        var eventLevels = ((supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners.flutter) || {}).eventLevels;
        var postMsgFn = function (t, p) {
            window.AnubhavFlutter.postMessage(JSON.stringify({
                type: t,
                payload: p,
            }));
        };
        addListener(PLATFORM.flutter, postMsgFn, eventLevels);
    }
    else if (window.Android && ((_c = supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners.android) === null || _c === void 0 ? void 0 : _c.enabled)) {
        app = "native";
        var eventLevels = ((supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners.android) || {}).eventLevels;
        var postMsgFn = function (t, p) {
            window.Android.on(t, JSON.stringify(p));
        };
        addListener(PLATFORM.android, postMsgFn, eventLevels);
    }
    else if (((_e = (_d = window["webkit"]) === null || _d === void 0 ? void 0 : _d.messageHandlers) === null || _e === void 0 ? void 0 : _e.nativeApp) && ((_f = supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners.ios) === null || _f === void 0 ? void 0 : _f.enabled)) {
        app = "native";
        var eventLevels = ((supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners.ios) || {}).eventLevels;
        var postMsgFn = function (t, p) {
            window["webkit"].messageHandlers.nativeApp.postMessage({ type: t, payload: p });
        };
        addListener(PLATFORM.ios, postMsgFn, eventLevels);
    }
    else if (window["self"] !== window["top"] && ((_g = supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners.iframe) === null || _g === void 0 ? void 0 : _g.enabled)) {
        app = "iframe";
        var eventLevels = ((supportedListeners === null || supportedListeners === void 0 ? void 0 : supportedListeners.iframe) || {}).eventLevels;
        var postMsgFn = function (t, p) {
            var _a;
            window.parent.postMessage({ event: t, metadata: p }, "".concat((_a = supportedListeners.iframe) === null || _a === void 0 ? void 0 : _a.targetOrigin));
        };
        addListener(PLATFORM.iframe, postMsgFn, eventLevels);
    }
    return { listeners: listeners, app: app };
}
// Attach a console listener to check if events are getting generated properly
export function attachConsoleListener(listeners) {
    if (listeners.length === 0 && process.env.NODE_ENV !== "production") {
        listeners.push(function (t, p, eventLevel) {
            console.log("[events] ".concat(eventLevel ? ": " + eventLevel + "] " : "").concat(t, ", payload: ").concat(JSON.stringify(p)));
        });
        console.debug("[events.config] Using default, console logged attached");
    }
}
export var EVENT_LEVELS;
(function (EVENT_LEVELS) {
    EVENT_LEVELS[EVENT_LEVELS["INFO"] = 0] = "INFO";
    EVENT_LEVELS[EVENT_LEVELS["DEBUG"] = 1] = "DEBUG";
})(EVENT_LEVELS || (EVENT_LEVELS = {}));
export var PLATFORM;
(function (PLATFORM) {
    PLATFORM["android"] = "Android";
    PLATFORM["ios"] = "iOS";
    PLATFORM["reactNative"] = "React Native";
    PLATFORM["flutter"] = "Flutter";
    PLATFORM["iframe"] = "iFrame";
})(PLATFORM || (PLATFORM = {}));
// attach anubhavExchange function to windows object
window.anubhavExchange = function (type, payload) {
    console.log("[exchange] type: '" + type + "', payload: " + payload);
    try {
        if (typeof payload === "string") {
            eventEmitter.emit(type, JSON.parse(payload || ""));
        }
        else {
            throw new Error("Payload invalid, please check");
        }
    }
    catch (error) {
        console.log("some error occured on event emitter", error);
    }
};
//# sourceMappingURL=index.js.map